import { render } from "./ManagerEditor.vue?vue&type=template&id=4fcaeccf&scoped=true"
import script from "./ManagerEditor.vue?vue&type=script&lang=js"
export * from "./ManagerEditor.vue?vue&type=script&lang=js"

import "./ManagerEditor.vue?vue&type=style&index=0&id=4fcaeccf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fcaeccf"]])

export default __exports__